<h1 mat-dialog-title>Enter an ID for the publication configuration</h1>
<div mat-dialog-content>  
  <form [formGroup]="form" (keydown.enter)="onSubmit()">
    <p>The first step is to come up with a computer-friendly label for the publication configuration. No spaces or weird characters please.</p>
    <mat-form-field>
      <mat-label>ID</mat-label>
      <input matInput formControlName="text" spellcheck="false">
      <mat-error>
        @if( id?.errors?.['required'] ) {
          <span>An ID is required.</span>
        }
        @if( id?.errors?.['urlSafeString'] ) {
          <span>No spaces or weird characters please.</span>
        }
        @if( id?.errors?.['nonunique'] ) {
            <span>That ID is already taken.</span>
          }
      </mat-error>
    </mat-form-field>

  </form>
</div>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()">Dismiss</button>
  <button mat-flat-button (click)="onSubmit()" [disabled]="form.invalid">Create Publication Configuration</button>
</mat-dialog-actions>